import { render } from "./OrderSummary.vue?vue&type=template&id=48765186&ts=true"
import script from "./OrderSummary.vue?vue&type=script&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&lang=ts"

import "./OrderSummary.vue?vue&type=style&index=0&id=48765186&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/transact/OrderSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48765186"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48765186', __exports__)) {
    api.reload('48765186', __exports__)
  }
  
  module.hot.accept("./OrderSummary.vue?vue&type=template&id=48765186&ts=true", () => {
    api.rerender('48765186', render)
  })

}


export default __exports__